<template>
  <div ref="intersectionWrapperRef">
    <slot v-if="isVisible" />
  </div>
</template>

<script setup lang="ts">
const { forceVisible = false } = defineProps<{
  /** Mount slot immediately (e.g. deep-link scroll to a below-fold section). */
  forceVisible?: boolean
}>()

const intersectionWrapperRef = ref<HTMLDivElement>()
const { intersectionHappened, stopObserving } = useIntersectionObserver(
  intersectionWrapperRef
)

const isVisible = computed(() => forceVisible || intersectionHappened.value)

watchEffect(() => {
  if (isVisible.value) {
    stopObserving()
  }
})
</script>
